// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221445/js/" + chunkId + "." + {"44":"e0887646","225":"72e87d85","481":"0d644eba","486":"be6ce356","770":"88081254"}[chunkId] + ".0.7077140089520383.chunk.js";
};